import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Button, Typography, Input, Spin, List, Avatar, Icon } from 'antd';

import emitter from '../Evt.js';

import ChatContext from './../ChatProvider';

import './order_chat.css';

const { TextArea } = Input;
const { Content } = Layout;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

function extractAndValidateXML(inputString) {
    // 使用正则表达式提取 XML 部分  
    const xmlMatch = inputString.match(/<\?xml.*?\?>[\s\S]*<\/\w+>/) || inputString.match(/<\w+>[\s\S]*<\/\w+>/);

    if (!xmlMatch) {
        return {
            isXml: false,
            data: inputString
        };
    }

    const xmlString = xmlMatch[0];

    // 创建一个 DOMParser 实例  
    const parser = new DOMParser();
    // 解析 XML 字符串  
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");

    // 检查解析错误  
    const parserError = xmlDoc.getElementsByTagName("parsererror");
    if (parserError.length > 0) {
        return {
            isXml: false,
            data: inputString
        };
    }

    return {
        isXml: true,
        data: new XMLSerializer().serializeToString(xmlDoc)
    };
}

function validateXML(xmlString) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
    const parserError = xmlDoc.getElementsByTagName('parsererror');

    return parserError.length === 0;
}

class OrderPage extends Component {
    static contextType = ChatContext;

    constructor(props) {
        super(props);

        this.pageName = 'tradeOrder';

        this.user = {};
        this.state = {
            
            filterError: '',

            // chat
            newMessage: '',

            requestLoadding: false
        };

        this.messagesEndRef = React.createRef(); // 创建 ref
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        if (this.messagesEndRef.current) {
            //this.messagesEndRef.current.scrollTop = this.messagesEndRef.current.scrollHeight;

            //this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            this.messagesEndRef.current.scrollTop = this.messagesEndRef.current.scrollHeight;
        }
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendError", this.callSendError);

        //this.scrollToBottom();

        this.context.initializeChat(this.pageName);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendError', this.callSendError);

    }

    callSendError = (status) => {
        switch (status) {
            case 0:
                this.context.setWithoutLastMessageList(this.pageName, -1);

                let message = this.formatHtml('Your order has been sent.');
                this.setBotTxtMessage(message);
                break;
            case 1:
                break;
            case 2:
                break;
        }
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
    }

    componentWillReceiveProps(props) {
        var { status, reply } = props;

        switch (status) {
            case 'send_trade_chat_message_success':
                if (this.state.requestLoadding) {
                    //console.log(reply);
                    
                    this.setState({ requestLoadding: false }, () => {
                        this.context.setWithoutLastMessageList(this.pageName, -1);

                        var matchResult = extractAndValidateXML(reply);
                        if (matchResult.isXml) {
                            // 去下单
                            window._hmt && window._hmt.push(['_trackEvent', 'Formula scan', 'trade', 'trade order']);

                            //console.log("matchResult.data: ", matchResult.data);
                            this.SendQuickSetup(matchResult.data);

                            //reply = 'Your order has been sent.';

                            //var txts = [<Spin key={1} />];

                            //this.context.addMessage(this.pageName, { text: txts, sender: 'bot' });

                        } else {
                            let message = this.formatHtml(reply);

                            this.setBotTxtMessage(message);
                        }
                    });
                }
                
                break;
            case 'send_trade_chat_message_fail':

                if (this.state.requestLoadding) {
                    this.setState({ requestLoadding: false }, () => {
                        this.context.setWithoutLastMessageList(this.pageName, -1);

                        this.setBotTxtMessage('fail');
                    });
                }
                break;
            default:
                break;
        }
    }

    SendQuickSetup(quickSetup) {
        this.setState({ requestLoadding: false }, () => {
            this.props.dispatch({
                type: "action_send_hub_message", payload: {
                    service: 'SendQuickSetup', userId: this.user.username,
                    msg: {
                        Category: 'QuickSetup',
                        Action: 'QuickSetup',
                        UserId: this.user.username,
                        QuickSetup: quickSetup,
                    }
                }
            });
        });
    }

    // 格式化聊天框显示内容
    formatHtml(txt) {
        if (txt === null || txt === undefined || txt === '') return '';

        var txts = [];
        var items = txt.split('\n');
        for (var item in items) {
            if (items[item] != '') {
                const trimmedLine = items[item].trim();
                if (trimmedLine.startsWith('//')) continue;

                if (txts.length > 0) txts.push(<br key={item} />);
                txts.push(trimmedLine);
            }
        }

        return txts;
    }

    setBotMessage = (botResponse) => {
        let i = 0; // Index for botResponse text elements  
        let j = 0; // Index for characters in the current string element  
        let currentText = ''; // Temporary string to hold the current bot message being constructed  

        // Initial setup to ensure there is a placeholder for the bot's current response  
        this.context.addMessage(this.pageName, { text: '', sender: 'bot', messageId: 0, buttons: [], showButtons: false });

        const interval = setInterval(() => {
            let charsToAdd = Math.floor(Math.random() * 20) + 1; // Random number of characters to add in each interval  
            let batchUpdate = false;

            while (charsToAdd > 0) {
                if (i >= botResponse.text.length) {
                    clearInterval(interval); // Clear interval when the response is fully built  

                    // Finalize the message and show buttons if there are any  
                    this.context.addWithoutLastMessageList(this.pageName, {
                        text: currentText,
                        sender: 'bot',
                        messageId: botResponse.messageId,
                        buttons: botResponse.buttons || [],
                        showButtons: !!botResponse.buttons && botResponse.buttons.length > 0
                    }, -1);

                    return; // Exit the function as the response is fully built  
                }

                if (j < botResponse.text[i].length) {
                    const nextChunk = botResponse.text[i].substring(j, j + charsToAdd); // Get the next chunk of characters  
                    currentText += nextChunk; // Append the chunk to current text  
                    j += charsToAdd; // Move the index forward by the number of characters added  
                    charsToAdd -= nextChunk.length;
                    batchUpdate = true;
                } else {
                    i++; // Move to the next element in botResponse  
                    j = 0; // Reset index for new string or element  
                }
            }

            if (batchUpdate) {
                this.context.addWithoutLastMessageList(this.pageName, {
                    text: currentText,
                    sender: 'bot',
                    messageId: 0,
                    buttons: [],
                    showButtons: false
                }, -1);
            }
        }, 5);
    };   

    // 设置聊天框内容
    setBotTxtMessage = (botResponse) => {
        let i = 0; // Index for botResponse elements
        let j = 0; // Index for characters in the current string element
        let currentText = []; // Temporary array to hold the current bot message being constructed
        

        this.context.addMessage(this.pageName, { text: [], sender: 'bot' });

        const interval = setInterval(() => {
            let charsToAdd = Math.floor(Math.random() * 30) + 1;
            let batchUpdate = false;

            while (charsToAdd > 0) {
                if (i >= botResponse.length) {
                    clearInterval(interval); // Clear interval when the response is fully built  
                    break;
                }

                if (typeof botResponse[i] === 'string') {
                    if (j < botResponse[i].length) {
                        const nextChunk = botResponse[i].substring(j, j + charsToAdd); // Get the next chunk of characters
                        currentText.push(nextChunk); // Append the chunk to current text
                        j += charsToAdd; // Move the index forward by the number of characters added
                        charsToAdd -= nextChunk.length;
                        batchUpdate = true;
                    } else {
                        i++; // Move to the next element in botResponse
                        j = 0; // Reset index for new string or element
                    }
                } else if (React.isValidElement(botResponse[i])) {
                    currentText.push(botResponse[i]); // Directly add the React element
                    i++; // Move to the next element
                    batchUpdate = true;
                } else {
                    i++;
                }
            }

            if (batchUpdate) {
                this.context.addWithoutLastMessageList(this.pageName, { text: currentText, sender: 'bot' }, -1);
            }
        }, 5);
    }

    // 聊天框内容变化
    handleMessageChange = e => {
        this.setState({ newMessage: e.target.value });
    };

    // 设置ctrl + enter 提交消息
    handleKeyDown = (event) => {
        if (event.ctrlKey && event.key === 'Enter') {
            event.preventDefault(); // 防止默认行为

            this.handleSendMessage();
        }
    }; 

    // 发送聊天消息
    handleSendMessage = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { newMessage } = this.state;

            let Prompt = newMessage;
            //console.log(Prompt);

            newMessage = this.formatHtml(newMessage);

            this.context.addMessage(this.pageName, { text: newMessage, sender: 'user' });

            var txts = [<Spin key={1} />];

            this.context.addMessage(this.pageName, { text: txts, sender: 'bot' });

            this.setState({ newMessage: '', requestLoadding: true }, () => {
                this.props.dispatch({
                    type: "action_send_trade_chat_message",
                    payload: { UserId: this.user.username, Prompt }
                });
            });
        }
    };

    createButton = (index, text, onClick, messageId, clicked) => {
        const disabledButtons = this.context.messageQueue[this.pageName].disabledButtons || {};
        return (
            <Button className={clicked ? 'chat-disabled-button' :''}
                key={Math.random()}
                size='small'
                type="primary"
                onClick={() => onClick(index)}
                disabled={disabledButtons[messageId]}
                style={{ marginLeft: 10 }}
            >
                {text}
            </Button>
        );
    };

    renderMessageContent = (item) => {
        return (
            <>
                <Typography.Text>{item.text}</Typography.Text>
                {item.showButtons && item.buttons && item.buttons.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                        {item.buttons.map((button, index) => this.createButton(index, button.text, button.onClick, item.messageId, button.clicked))}
                    </div>
                )}
            </>
        );
    }

    render() {
        var { newMessage, requestLoadding } = this.state;

        let messages = [];
        if (this.user.username !== undefined) {
            messages = this.context.getMessages(this.pageName, );
        }
        
        var textareaPlaceholder = '';
        textareaPlaceholder += String.fromCharCode(10);

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title.newScan']}</title>
                <meta name="keywords" content={languageMessages['vernacular keywords']} />
                <meta name="description" content={languageMessages['description.scan']} />

                <meta property="og:title" content={languageMessages['title.newScan']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description.scan']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title.newScan']} />
                <meta name="twitter:description" content={languageMessages['description.scan']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{'Trade setup'}</h1>)} />
                </div>
                <Layout style={{ padding: '0px 50px', marginBottom: '20px' }}>

                    <Layout className='chat-content' style={{ margin: '40px 0', height: 'calc(100vh - 326px)' }}>
                        <Content style={{ border: '1px solid #cdcdcd', marginLeft: '10px' }}>
                            <div className='chat-items'>
                                <div ref={this.messagesEndRef} className="chat-messages">
                                    {messages.length > 0?
                                    (<List
                                        dataSource={messages}
                                        renderItem={item => (
                                            <List.Item className={`message ${item.sender === 'bot' ? 'bot' : 'user'}`}>
                                                {item.sender === 'bot' ? (
                                                    <List.Item.Meta
                                                        avatar={<Avatar src="/static/images/icon-robot.png" />}
                                                        title=""
                                                        description={this.renderMessageContent(item)}
                                                    />
                                                ) : (
                                                        <List.Item.Meta
                                                            title=""
                                                            description={this.renderMessageContent(item)}
                                                            className="user-message"
                                                        />
                                                    )}
                                            </List.Item>
                                        )}
                                        />)
                                        : (<div className='chat-outer-cont'>
                                            <div className='chat-center-left'>Tell me how you want to trade. e.g.<br />
                                            long 300 shares WDC on bid+0.01, target for $3 profit, hold for 5 days at most.<br />
                                            short 200 shares MSFT at ask-0.01, target for $3 profit, hold for 5 hours.
                                        </div>
                                        </div>)
                                    }
                                </div>
                                <div className="chat-input">
                                    <div className="chat-input-cont">
                                        <TextArea
                                            placeholder={textareaPlaceholder}
                                            value={newMessage}
                                            onChange={this.handleMessageChange}
                                            onKeyDown={this.handleKeyDown}
                                            rows={4}
                                            className="custom-textarea"
                                        />
                                        <Button
                                            type="primary"
                                            loading={requestLoadding}
                                            disabled={requestLoadding || newMessage === ''}
                                            onClick={this.handleSendMessage}
                                            className="custom-send-button"
                                        >
                                            <Icon type="upload" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Content>
                    </Layout>
                    
                </Layout>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.order;
}

const page = connect(mapStateToProps)(OrderPage);
export { page as default }